export default __webpack_public_path__ + "static/media/1316.de6daa18.png";